export default __webpack_public_path__ + "static/media/Group 30886.029c1ea8.png";